import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * A higher order component that applies default props to a component. It additionally forwards the ref.
 * @param Component The component to apply default props to.
 * @param defaultProps The default props to apply.
 */
export function withDefaults(Component, defaultProps = {}) {
    return forwardRef((_a, ref) => {
        var { children } = _a, props = __rest(_a, ["children"]);
        return (_jsx(Component, Object.assign({ ref: ref }, defaultProps, props, { children: children }), void 0));
    });
}
//# sourceMappingURL=withDefaults.js.map